import styled from '@emotion/styled';

export const TestReportContent = styled('p')`
  text-align: center;
  line-break: anywhere;
`;
